export const CLICKABLE_MODULE_SUMMARY_IDS = [
  "receivables-module",
  "organisation-module",
  "cashflow-module",
];

export const SUBSCRIPTION_ADDONS_PATH = "/settings/subscription/addons";
export const MODULE_QUERY_PARAM = "module";
